import { render, staticRenderFns } from "./VerifyEmailView.vue?vue&type=template&id=6d3c53e6&scoped=true&"
import script from "./VerifyEmailView.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailView.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/all.css?vue&type=style&index=0&id=6d3c53e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3c53e6",
  null
  
)

export default component.exports